import React from "react"
import Capabilites from "../../imagens/logos/logoCapabilities.png"
import { Link } from "react-router-dom"
import imgEngineering from "../../imagens/devProduto.png"
import imgProduction from "../../imagens/imgProduction.png"
import imgTooling from "../../imagens/imgTooling.png"
import "./chooseCapabilities.css"


function EngineerOrProduction() {
    return (
        <div>
            <div className='text-start mb-2 ms-2'>
                <img className="img-fluid img-custom-size" src={Capabilites} alt="capabilities"></img>
            </div>
                <div className="engineerOrProduction pt-5">
                    <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom mt-2">
                        <Link className="text-decoration-none" to="/Capabilities/Production">
                            <img src={imgProduction} className="img-fluid" alt="Machine Capabilities" />
                            <h3 className="textCapabilities text-wrap text-center mt-2  s-md-5">Production capabilities</h3>
                        </Link>
                    </div>
                    <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom mt-2">
                        <Link className="text-decoration-none" to="/Capabilities/Engineering">
                            <img src={imgEngineering} className="img-fluid" alt="Machine Capabilities" />
                            <h2 className="textCapabilities text-wrap text-center mt-2  s-md-5">Engineering and Product development</h2>
                        </Link>
                    </div>
                    <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom mt-2">
                        <Link className="text-decoration-none" to="/Capabilities/ToolingAndManufacturing">
                            <img src={imgTooling} className="img-fluid" alt="Machine Capabilities" />
                            <h2 className="textCapabilities text-wrap text-center mt-2  s-md-5">In-house toolings design and manufacturing</h2>
                        </Link>
                    </div>
            </div>
        </div >
    )
}

export default EngineerOrProduction